import { render, staticRenderFns } from "./PptLayerTree.vue?vue&type=template&id=db8b1a34&"
import script from "./PptLayerTree.vue?vue&type=script&lang=js&"
export * from "./PptLayerTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db8b1a34')) {
      api.createRecord('db8b1a34', component.options)
    } else {
      api.reload('db8b1a34', component.options)
    }
    module.hot.accept("./PptLayerTree.vue?vue&type=template&id=db8b1a34&", function () {
      api.rerender('db8b1a34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/PptLayerTree.vue"
export default component.exports